<template>
    <form-container :headerText="title" :width="550" action="editSpielPlan"
                    :valid-actions="['editSpielPlan']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-autocomplete :disabled="!user.permissions.ergebnisdienst"
                            class="my-3" v-model="dataObject.heim.teamId" item-value="id" item-text="name"
                            no-data-text="keine Daten gefunden"
                    :items="mannschaften" dense label="Heimmannschaft" :rules="[rules.required]"></v-autocomplete>
            <v-autocomplete :disabled="!user.permissions.ergebnisdienst"
                            class="my-3" v-model="dataObject.gast.teamId" item-value="id"
                            item-text="name" no-data-text="keine Daten gefunden"
                    :items="mannschaften" dense label="Auswärtsmannschaft" :rules="[rules.required]"></v-autocomplete>
            <v-radio-group :disabled="!user.permissions.ergebnisdienst" v-if="!isCup"
                            v-model="dataObject.saison.semester" :rules="[rules.required]" row>
                <v-radio v-for="(type, n) in semesterTypes" :key="n"
                         :label="type.label" :value="type.value"></v-radio>
            </v-radio-group>
            <v-text-field :disabled="!user.permissions.ergebnisdienst"
                          v-model="dataObject.saison.runde" :rules="[rules.required]"
                          label="Rundennummer" type="number">
            </v-text-field>
            <v-text-field :disabled="!user.permissions.ergebnisdienst" v-if="isCup"
                          v-model="dataObject.saison.rundeText" :rules="[]"
                          label="Rundentext (z.B. Viertelfinale)">
            </v-text-field>
            <v-radio-group v-model="dataObject.infos.wochentag" :rules="[rules.required]" row>
                <v-radio v-for="(day, n) in weekdays" :key="n"
                         :label="day" :value="day" class="mb-3"></v-radio>
            </v-radio-group>
            <v-text-field type="date" v-model="dataObject.infos.datum"
                          label="Datum" :rules="[rules.required]">
            </v-text-field>
            <v-text-field type="time" v-model="dataObject.infos.uhrzeit"
                          label="Uhrzeit" :rules="[rules.required]">
            </v-text-field>
            <v-text-field v-model="dataObject.infos.ort" label="Ort" :rules="[rules.required]">
            </v-text-field>
            <v-text-field v-model="dataObject.infos.bahn" label="Bahn" :rules="[rules.required]">
            </v-text-field>
            <v-checkbox v-if="dataObject.admin !== undefined" v-model="hasAdmin" label="hat einen externen Administrator (optional)"></v-checkbox>
            <v-autocomplete v-if="hasAdmin" :disabled="!user.permissions.ergebnisdienst"
                            class="my-3" v-model="dataObject.admin" item-value="id"
                            item-text="name" no-data-text="keine Daten gefunden"
                            :items="users" dense label="Externer Administrator (optional)"/>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "../../services/formRules";
    import ErrorMsg from "../../components/elements/errorMsg";
    import SpielService from "../../services/data/spielService";
    import {Spiel} from "../../services/data/spiel";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: { ErrorMsg, FormContainer},
        name: "spiel-plan-edit",
        props: ['currentData', 'saison', 'default', 'isCup'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
            weekdays: ['Sa', 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr'],
            hasAdmin: false,
            users: []
        }),
        computed: {
            user(){ return this.$store.state.user; },
            title(){ return this.currentData ? 'Spiel ändern' : 'Spiel anlegen' },
            semesterTypes(){ return this.$store.state.local.semesterTypes; },
            mannschaften() { return this.saison.getSortedTeamList(); }
        },
        created(){
            this.rules = new FormRules();
            this.dataObject = new Spiel(this.saison.anzahlSpieler,
                                        this.saison.anzahlErsatzSpieler,
                                        this.saison.eintauschVorEinspielzeit,
                                        this.saison.freieSpieler, this.isCup);
            if ( this.isCup ) this.dataObject.saison.semester = 'C'
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
            }
            this.dataObject.saison.id = this.saison.id; // set always because id is not saved in spiel on saison
            if ( this.default && !this.dataObject.id ) {
                this.dataObject.saison.semester = this.default.semester;
                this.dataObject.saison.runde = this.default.runde;
            }
            if ( this.dataObject.admin !== '' && this.dataObject.admin !== undefined ) this.hasAdmin = true
        },
        methods: {
            async save(){
            // check weekday against date
                const dateCheck = new Date(this.dataObject.infos.datum);
                const dayInputIndex = this.weekdays.indexOf(this.dataObject.infos.wochentag)-1;
                const dayInput = dayInputIndex === -1 ? 6 : dayInputIndex;
                if ( dateCheck.getDay() !== dayInput ) {
                    this.error = 'Achtung: der gewählte Wochentag passt nicht zum gewählten Datum!';
                    return
                }
            // set data object
                this.dataObject.setVereineFromMannschaften(this.mannschaften);
                this.dataObject.setPending();
                this.dataObject.saison.lvId = this.saison.lvId;
            // save data
                this.$store.state.local.loader = true;
                if ( !this.currentData ) {
                // new Spiel
                    let reply = await this.dataObject.saveNew('document');
                    if ( reply.successful ) {
                        this.updateSaison(reply.content, this.dataObject);
                    } else {
                        this.error = this.dataObject.getDBErrorText(reply.content);
                    }
                } else if ( this.dataObject.setDocumentUpdates(this.currentData) ) {
                // update Spiel
                    let reply = await this.dataObject.saveEdited('spiel_edit');
                    if ( reply.successful ) {
                        window.history.back();
                        const text = 'Das Spiel wurde erfolgreich geändert!';
                        this.successSnack(text);
                    } else {
                        this.error = this.dataObject.getDBErrorText(reply.content);
                    }
                } else {
                    window.history.back();
                }
                this.$store.state.local.loader = false;
            },
            successSnack(text){
                this.$store.dispatch('clearSnackbar');
                this.$store.state.globalSnack.color = 'success';
                this.$store.state.globalSnack.text = text;
                this.$store.state.globalSnack.show = true;
            },
            async updateSaison(id, spiel){
                this.saison.local.documentUpdates = {
                    ['spiele.' + id]: SpielService.getExcerptForSaison(spiel),
                };
                await this.saison.saveEdited('saison_edit');
                this.saison.local.documentUpdates = {};
                window.history.back();
                const text = 'Das Spiel wurde erfolgreich angelegt!';
                this.successSnack(text);
            },
            async loadUsers(){
                if ( this.users.length > 0 ) return
                const users = await FirebaseRead.readFullList('users')
                this.users = users.map (user => ({id: user.id, name: user.lastName + ' ' +
                                                    user.firstName + ' (' + user.email + ')'}))
                                    .sort((a, b) => a.name > b.name ? 1 : -1);
            }
        },
        watch: {
            hasAdmin(to, from){
                if ( to && !from ) this.loadUsers()
            }
        }
    }
</script>

<style scoped>

</style>